module.exports = __webpack_public_path__ + "static/media/sheep.672c63d9.svg";